import { Box, styled } from '@mui/material';

export const StyledDefaultCameraSize = styled(Box)(() => ({
  minHeight: '36rem',
  minWidth: '64rem',
}));

export const StyledNoActiveCameraMessage = styled(StyledDefaultCameraSize)(
  ({ theme }) => ({
    color: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem',
  }),
);

export const StyledSixteenByNineAspectRatio = styled(Box)(({ theme }) => ({
  paddingBottom: '56.25%',
  backgroundColor: theme.palette.custom.tab,
}));

export const StyledCameraContent = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: '.2rem',
  '& .pause-button': {
    display: 'none',
  },
  '&:hover .pause-button': {
    display: 'flex',
  },
}));

export const StyledCameraWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
  marginBottom: '2rem',
  padding: '1rem',
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    width: '50%',
  },
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
}));
